module.exports = "/assets/data/ff3a02b7e961da2a4e2aa79475581f28-L6.data.json";